import React from "react";
// import Button from "../../../../../../common/Button";

const ClearButton = props => (
  <button 
    className="bg_wht grn del off" 
    onClick={ props.onClear }
  />
  // <Button className="del_note" onClick={ props.onClear }>
  //   <img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_remove.svg` } alt="" />
  // </Button>
);

export default ClearButton;
